<script lang="ts" setup>
import { ref, nextTick } from "vue"; 
import { useForm, } from "@/helpers/composables/useForm";
import { route } from "ziggy-js";
import { object, string } from "yup";
import Recaptcha from "@/components/Recaptcha.vue";
import RothcoCta from "@/components/RothcoCta.vue";
import { usePage } from "@inertiajs/vue3";

let props = defineProps({
    authKey: {
        type: String,
        default: null
    },
    d2cOnly: {
        type: Boolean,
        default: false
    }
});

let form = useForm({
    useInertia: true,
    schema: object({
        token: string().required('2FA Token is required').test({
            name: "token_length",
            message: "2FA Token is 10 characters long.",
            test: (value) => {
                return value.split(" ").length === 10;
            }
        }).default(''),
        captchaResponse: string().required()
    })
});

let errors = ref({});

const emit = defineEmits(["setAsLoggedIn"]);

const setAsLoggedIn = () => {
    emit("setAsLoggedIn");
};

const login = async ()=>{
    if(form.processing) return;
    
    await form.validate();
    nextTick(()=>{
        if(Object.keys(form.errors).length == 0){
            form.transform((data)=>{
                return {
                    token: data.token?.split(" ").join(""),
                    email: props.authKey,
                    'g-recaptcha-response': data.captchaResponse
                }
            })
            .post(
                route(props.d2cOnly ? "authenticate.token" : "web.two-factor-authentication.login"),
                {
                    onSuccess: (page) => {
                        if(props.d2cOnly ){
                            setAsLoggedIn();
                        }
                    },
                    onError: () => {
                        errors.value = usePage().props.errors;
                    }
                }
            );
        }
    })
}
</script>
<template>
    <form class="authorization-form" @submit.prevent="login()">
        <p>Please check your email for your Two-Factor Authorization token.</p>
        <div class="input-folder">
            <div class="input-folder--input">
                <PrimeInputMask 
                    v-model="form.token"
                    id="token" 
                    placeholder=" " 
                    required
                    :class="{'error': form.errors.token}"
                    style="text-transform: uppercase"
                    mask="* * * * * * * * * *"
                />
                <label for="token">
                    <p class="paragraph-default">2FA Token</p>
                </label>
            </div>
            <div class="input-folder--support">
                <p class="input-suport-text invalid-state" v-if="form.errors.token"> {{ form.errors.token}}</p>
            </div>
        </div>
        <div class="footer-row">
            <Recaptcha ref="recaptcha" v-model="form.captchaResponse" theme="light" />
        </div>
        <div class="footer-row">
            <RothcoCta id="loginBtn" :disabled="form.processing" type="submit" ctaType="button" class="primary">
                Login
            </RothcoCta>
        </div>
    </form>
</template>